import {Dispatch, SetStateAction, useEffect} from 'react';
// import axios from 'axios';

// import {getAdResponse} from '@jobseeker/common-core/utils';
import getAds from '@jobseeker/common-core/helpers/loadAds';

import type {SectionElementType, AdsOptions} from '@jobseeker/common-core/types';

const useLoadAds = (
  slotId: string,
  setAds: Dispatch<
    SetStateAction<
      | SectionElementType[]
      | /* eslint-disable @typescript-eslint/no-explicit-any */ any
    >
  >,
  options?: AdsOptions,
  isCourseAds? = false,
  loadAds? = true,
  setAdsLoaded?: Dispatch<SetStateAction<boolean>>,
  enabled? = true
) => {
  useEffect(() => {
    // FIXME: The following API is being triggered multiple times due to changes in `exp` and `user_location`.
    // Implement debouncing or another optimization to resolve this.

    if (!enabled) return;
    const loadAdsApi = async () => {
      const adsInfo = await getAds(slotId, options, isCourseAds);
      if (adsInfo?.length > 0) {
        setAds(adsInfo);
      }
      setAdsLoaded && setAdsLoaded(true);
    };

    if (loadAds && slotId) {
      loadAdsApi();
    } else {
      setAdsLoaded && setAdsLoaded(true);
    }
  }, [
    slotId,
    setAds,
    loadAds,
    enabled,
    options?.logged,
    options?.exp,
    options?.user_location,
  ]);
};

export default useLoadAds;
